import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "./index.css";

// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";

import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

// Pages
import LandingPage from "./LandingPage";
import Login from "./Login";
import Register from "./Register";
import VerifyEmailOtp from "./VerifyEmailOtp";
import Dashboard from "./Dashboard";
import App from "./signin/App";
import Profile from "./settings/Profile";
import SecurityAuthentication from "./settings/SecurityAuthentication";
import DigitalIdentity from "./settings/DigitalIdentity";
import Certificates from "./settings/Certificates";
import Organizations from "./settings/Organizations";
import Integrations from "./settings/Integrations";
import AuditLogs from "./settings/AuditLogs";
import BackupRecovery from "./settings/BackupRecovery";
import SystemPreferences from "./settings/SystemPreferences";
import PostQuantum from "./settings/PostQuantum";
import AnchoredRecords from "./settings/blockchain/AnchoredRecord";
import AnchorOverview from "./settings/blockchain/BlockchainAnchoring";
import BlockchainSettings from "./settings/blockchain/BlockchainSettings";
import IPFSFiles from "./settings/blockchain/IPFSFiles";
import Nodes from "./settings/blockchain/Nodes";
import SmartContracts from "./settings/blockchain/SmartContracts";
import VerificationsPage from "./settings/VerificationsPage";
import MyNotifications from "./settings/MyNotifications";
import Adduser from "./Adduser";
import TrustPolicies from "./TrustPolicies";
import TrustScore from "./TrustScore";


import ReviewSign from "./signin/review";
import SignSuccess from "./signin/success";
import CustomizeSignature from "./signin/CustomizeSignature";

import SenderPlacement from "./SenderPlacement";
import VerificationPage from "./verified files/Verificationpage";
import Automation from "./verified files/automatic";
import AITamperDetection from "./verified files/AI Temper";
import PKIValidation from "./verified files/Policy";
import VerificationResult from "./verified files/Verificationresult";
import VerificationReport from "./verified files/Verificationreport";
import ContactsPage from "./ContactsPage";
import UsersControl from "./UsersControl";
import SignPage from "./SignPage";

import InviteHandler from "./InviteHandler";

//Request
import AddRecipients from './request/AddRecipients';
import ReceiveAndSend from './request/ReviewAndSend';
import RequestSignaturePage from "./request/RequestSignaturePage";
import SetVerification from "./request/SetVerification";
import RequestSuccess from "./request/RequestSuccess";
import RequestStatusPage from "./request/RequestStatusPage";
import RequestDetailsPage from "./request/RequestDetailsPage";

//SecureDrive
import Upload from "./secure/Upload";
import Drive from "./secure/Drive";
import FileDetails from "./secure/FileDetails";
import FileVersion from "./secure/FileVersion";
import ShareFile from "./secure/ShareFile";
import ActivityLog from "./secure/ActivityLog";


//ArtifactSigning
import UploadArtifact from "./artifact/UploadArtifact";
import GenerateManifest from "./artifact/GenerateManifest";
import SigningMode from "./artifact/SigningMode";
import ReviewArtifact from "./artifact/ReviewArtifact";
import Integration from "./artifact/Integration";
import OTADeployment from "./artifact/OTAdeployment";
import Downloads from "./artifact/Downloads";
import RestApi from "./artifact/RestApi";
import Complete from "./artifact/Complete";


import VerifyArtifactUpload from "./verified files/VerifyArtifactUpload";
import ArtifactIntegrity from "./verified files/ArtifactIntegrity";
import ChooseVerificationType from "./verified files/ChooseVerificationType";






//AI
import AISecurityDashboard from "./ai/AISecurityDashboard";
import OrganizationDashboard from "./ai/OrganizationDashboard";
import ComplianceDashboard from "./ai/ComplianceDashboard";
import HSMDashboard from "./ai/HSMDashboard";
import Reports from "./ai/Reports";
import TimestampOverview from "./timestamp/Overview";
import TimestampVerification from "./timestamp/Verification";
import TimestampRecords from "./timestamp/TimestampRecords";
import TimeSources from "./timestamp/TimeSources";
import Authorities from "./timestamp/Authorities";
import TimeSettings from "./timestamp/TimeSettings";



// Layout
import Layout from "./components/Layout";
import SelectIdentity from "./signin/signdoc";
import ChooseMode from "./signin/choosemode";
import AdvancedOptionsPage from "./signin/advanced";
import RolesManagement from "./roles";
import PermissionsMatrix from "./permission";
import ChooseSigningMethod from './artifact/ChooseSigningMethod';
import CICDSetup from './artifact/CICDSetup';


// Send the login token with every axios request, so protected APIs
// (for example /api/digital-id/list) accept the call.
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token && !config.headers?.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Protect Private Pages
function ProtectedRoute({ children }) {
  const token = localStorage.getItem("token");

  return token ? children : <Navigate to="/login" replace />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Routes>
      {/* Public Pages */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      {/* INVITE ROUTE */}
      <Route path="/invite/:token" element={<InviteHandler />} />


      {/* Protected Pages */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route
  path="/verify-email-otp"
  element={
    <VerifyEmailOtp />
  }
/>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="/register" element={<Register />} />
        <Route path="app" element={<App />} />
        <Route path="drive" element={<Drive />} />
        <Route path="settings/settings-profile" element={<Profile />} />
        <Route path="settings/security-authentication" element={<SecurityAuthentication />} /> 
        <Route path="settings/digital-identity" element={<DigitalIdentity />} /> 
        <Route path="settings/certificates" element={<Certificates />} /> 
        <Route path="settings/organizations" element={<Organizations />} />
        <Route path="settings/integrations" element={<Integrations />} /> 
        <Route path="settings/audit-logs" element={<AuditLogs />} /> 
        <Route path="settings/backup-recovery" element={<BackupRecovery />} /> 
        <Route path="settings/system-preferences" element={<SystemPreferences />} />
        <Route path="settings/post-quantum" element={<PostQuantum />} />
        <Route path="settings/blockchain-anchoring" element={<AnchorOverview />} />
        <Route path="blockchain-anchoring" element={<AnchorOverview />} />
        <Route path="blockchain-anchoring/anchored-records" element={<AnchoredRecords />} />
        <Route path="blockchain-anchoring/ipfs-files" element={<IPFSFiles />} />
        <Route path="blockchain-anchoring/verifications" element={<VerificationsPage />} />
        <Route path="blockchain-anchoring/nodes" element={<Nodes />} />
        <Route path="blockchain-anchoring/smart-contracts" element={<SmartContracts />} />
        <Route path="blockchain-anchoring/settings" element={<BlockchainSettings />} />


        <Route path="settings/my-notifications" element={<MyNotifications />} />
        <Route path="request-signatures" element={<RequestSignaturePage />} />
        <Route path="add-recipients" element={<AddRecipients />} />
        <Route path="review-and-send" element={<ReceiveAndSend />} />
        <Route path="set-verification" element={<SetVerification />} />
        <Route path="request-success" element={<RequestSuccess />} />
        <Route path="request-status" element={<RequestStatusPage />} />
        <Route path="/request-details/:id" element={<RequestDetailsPage />} />
        <Route path="drive" element={<Drive />} />
        <Route path="upload" element={<Upload />} />
        <Route path="file-details" element={<FileDetails />} />
        <Route path="file-version" element={<FileVersion />} />
        <Route path="share" element={<ShareFile />} />
        <Route path="activity" element={<ActivityLog />} />
        <Route path="placement/:token" element={<SenderPlacement />} />
        <Route path="verification" element={<VerificationPage />} />
        <Route path="automatic-verification" element={<Automation />} />
        <Route path="ai-tamper-detection" element={<AITamperDetection />} />
        <Route path="policy-key-validation" element={<PKIValidation />} />
        <Route path="verification-result" element={<VerificationResult />} />
        <Route path="verification-report" element={<VerificationReport />} />
        {/* <Route path="placeholder-sign" element={<PlaceHolderSign />} /> */}
        <Route path="settings/contacts" element={<ContactsPage />} />
        <Route path="users-control" element={<UsersControl />} />
        <Route path="sign/:token" element={<SignPage />} />
        <Route path="signdoc" element={<SelectIdentity />} />
        <Route path="choosemode" element={<ChooseMode />} />
        <Route path="customize-signature" element={<CustomizeSignature />} />
        <Route path="add-user" element={<Adduser />} />
        <Route path="advanced" element={<AdvancedOptionsPage />} />

        <Route path="advancedoptions" element={<AdvancedOptionsPage />} />
        <Route path="reviewsign" element={<ReviewSign />} />
        <Route path="success" element={<SignSuccess />} />
        <Route path="AI-security" element={<AISecurityDashboard />} />
        <Route path="reports" element={<Reports />} /> 


        <Route path="upload-artifact" element={<UploadArtifact />} />
        <Route path="generate-manifest" element={<GenerateManifest />} />
        <Route path="signing-mode" element={<SigningMode />} />
        <Route path="review-artifact" element={<ReviewArtifact />} />            
        <Route path="integration" element={<Integration />} /> 
        <Route path="ota-deployment" element={<OTADeployment />} />
        <Route path="downloads" element={<Downloads />} />
        <Route path="rest-api" element={<RestApi />} />      
        <Route path="complete" element={<Complete/>} />        
        <Route path="Organization" element={<OrganizationDashboard />} />
        <Route path="Compliance" element={<ComplianceDashboard />} /> 
        <Route path="HSM-management" element={<HSMDashboard />} />
        <Route path="trust-policies" element={<TrustPolicies />} />
        <Route path="trust-score" element={<TrustScore />} />
        <Route path="timestamps" element={<TimestampOverview />} />
        <Route path="roles" element={<RolesManagement />} />
        <Route path="/permissions" element={<PermissionsMatrix />} />
        <Route path="timestamps/verification" element={<TimestampVerification />} />
        <Route path="timestamps/records" element={<TimestampRecords />} />
        <Route path="timestamps/TimeSource" element={<TimeSources />} />
        <Route path="timestamps/authorities" element={<Authorities />} />
        <Route path="timestamps/settings" element={<TimeSettings />} />
        <Route path="choose-signing-method" element={<ChooseSigningMethod />} />
        <Route path="ci-cd-setup" element={<CICDSetup />} />
        <Route path="artifact-verification" element={<VerifyArtifactUpload />} />
        <Route path="artifact-integrity" element={<ArtifactIntegrity />} />
        <Route path="verify-trust" element={<ChooseVerificationType />} />

      </Route>

      {/* Unknown Page Redirect */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter>
);